import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import { Box, Modal } from '@mui/material';
import { ReactComponent as ExternalLinkIcon } from "../../../../Assets/img/card/External link.svg"
// import { ReactComponent as CardWaveShadow } from "../../../../Assets/img/card/preview-card-wave-with-shadow.svg"
import { useCreateCardDetailContext } from '../../../CreatecardDetailContext';
import { useUserDetailContext } from '../../../UserDetailContext';
import { ReactComponent as ImQrcode } from "../../../../Assets/img/icons/QrCode_AllCards.svg";
import { ReactComponent as IoMdShare } from "../../../../Assets/img/icons/Share.svg";
import { MdOutlinePhoneIphone } from "react-icons/md";
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { ReactComponent as WhatsappFilled } from '../../../../Assets/img/icons/whatsapp-filled.svg';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import DefaultProfileBg from "../../../../Assets/img/card/profilebg.png"
import DefaultLogo from "../../../../Assets/img/default-logo.png";
// import ReactDOM from 'react-dom';
import QRCodeStyling from "qr-code-styling";
// import imglogo from '../../../../Assets/img/logo.svg'
// import { ReactComponent as NeocardzWave } from "../../../../Assets/img/card/Neocardz wave.svg";
// import { ReactComponent as LinkedinIcon } from "../../../../Assets/img/icons/linkedin.svg"
// import { ReactComponent as WhatsappIcon } from "../../../../Assets/img/icons/whatsapp.svg"
// import { ReactComponent as FacebookIcon } from "../../../../Assets/img/icons/icons8-facebook.svg"
// import { ReactComponent as InstagramIcon } from "../../../../Assets/img/icons/instagram.svg"
import MapIntegration from '../../Mapintegration';
import { socialLinksSections, getIconAndLabel } from '../../../Utilities/SocialMediaMapping'
import PreviewFileItem from '../../../Utilities/PreviewFileItem';
// import NeocardzWave from '../../../Utilities/NeocardzWave';
// import CardWaveStd from '../../../Utilities/CardWaveStd';
// import CardWaveSmile from '../../../Utilities/CardWaveSmile2';
import { renderLayout } from '../Layouts';
import EventIcon from '@mui/icons-material/Event';
import ReactPlayer from 'react-player';

// Share imports
import { Typography, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { saveAs } from 'file-saver';
import { ReactComponent as Download } from "../../../../Assets/img/icons/Download-share.svg"
import CloseIcon from "@mui/icons-material/Close";
import facebook from '../../../../Assets/img/icons/Facebook.svg'
import whatsapp from '../../../../Assets/img/icons/whatsapp.svg'
import insta from '../../../../Assets/img/icons/instagram.svg'
import linkedin from '../../../../Assets/img/icons/linkedin.svg'
import signal from '../../../../Assets/img/icons/signal.svg'
import telegram from '../../../../Assets/img/icons/Telegram.svg'
import QrCodeCard from "../QrCodeCard";
import { ReactComponent as NonVerifiedTickNew } from "../../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as VerifiedTickN } from "../../../../Assets/img/icons/Verified-icon-new.svg";
import ShareQR from '../ShareQR';
import MapWithAddress from '../../MapWithAddress';
const baseUrls = require('../../../../config/sociallinksurl.json')

const CreatePreview = ({ isInsideModal = false, activeItem }) => {


  const objectId = localStorage.getItem("objectId");
  const { additionalFields, setAdditionalFields, cardDetails, CardStyles, CardQrStyles, ContactStyles, SocialLinks, AttachDocs } = useCreateCardDetailContext();

  const anySocialIconsVisible = SocialLinks && SocialLinks.links.some(link => link && link.visible);

  const visibleFiles = (files) => files.filter(file => file.visible); // Hide the attached files that are marked invisible

  const { userDetails } = useUserDetailContext();
  // console.log("create preview card details", cardDetails);

  const fullName = userDetails.name;
  const [firstName, lastName] = fullName.split(' ');

  const companyName = cardDetails.company || "Company";
  const userDesignation = cardDetails.designation || "Designation";
  const userCategory = cardDetails.CardType || "Category";

  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [labelColor, setLabelColor] = useState('#ffffff');
  const [sharePopover, setSharePopover] = useState(false);

  // useEffect(() => {
  //   const lat = parseFloat(ContactStyles.latitude);
  //   const lon = parseFloat(ContactStyles.longtitude);

  //   if (!isNaN(lat) && !isNaN(lon)) {
  //     setLatitude(lat);
  //     setLongitude(lon);
  //   } else {
  //     setLatitude('');
  //     setLongitude('');
  //   }
  // }, [ContactStyles.latitude, ContactStyles.longtitude]);

  const bgColor = CardStyles?.bgColor || '#ffffff';
  const layoutColor = CardStyles?.colorLayout || '#0044c6';

  const getFontWeight = (style) => {
    switch (style) {
      case 'Light':
        return 300; // Font weight for Light
      case 'Regular':
        return 500; // Font weight for Regular
      case 'Medium':
        return 600; // Font weight for Medium
      case 'Semi Bold':
        return 700; // Font weight for Semi Bold
      case 'Bold':
        return 800; // Font weight for Bold
      default:
        return 'normal'; // Default font weight
    }
  };
  const addressData = {

    city: "Banglore",
    state: "Karnataka",
    postal_code: "582101",
    country: "India",
  };

  // const fullAddress = `${ContactStyles.address}, ${ContactStyles.city}, ${ContactStyles.state} ${ContactStyles.postal_code}, ${ContactStyles.country}` || `${addressData.city}`;

  const fullAddress = (ContactStyles?.address || ContactStyles.city)
    ? `${ContactStyles?.address}, ${ContactStyles?.city}, ${ContactStyles?.state} ${ContactStyles?.postal_code}, ${ContactStyles?.country}`
    : `${addressData.city}, ${addressData.state}, ${addressData.postal_code}, ${addressData.country}`;

  const getDisplayTitle = (title) => {
    switch (title) {
      case "Social Media":
        return "My Social Network";
      case "Business":
        return "My Businesses";
      case "Contact":
        return "My Contacts"
      case "Payment":
        return "My Payment Links"
      case "More":
        return "Others"
      case "Music":
        return "My Music"
      case "Portfolio":
        return "My Portfolio"
      case "Content":
        return "My Content"
      default:
        return title;
    }
  };

  const getLuminance = (hex) => {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance;
  };

  useEffect(() => {
    const luminance = getLuminance(layoutColor);
    if (luminance > 0.5) {
      setLabelColor('#000000'); // Dark text for light background
    } else {
      setLabelColor('#ffffff'); // Light text for dark background
    }
  }, [layoutColor]);

  const canvasToImage = (canvas, type) => {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, type);
    });
  };

  let phoneNo = userDetails?.phoneNo || "";
  phoneNo = phoneNo.replace(/\s+/g, "");

  const [url, setUrl] = useState(`${process.env.REACT_APP_CARD_URL}/digital-identity/${CardQrStyles?.CardName || CardQrStyles?.CardType}/${objectId}`);

  const message = url;
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNo}&text=${encodedMessage}`;
  // const telegramUsername = "YourTelegramUsername"; 
  const telegramLink = `https://t.me/${phoneNo}?text=${encodedMessage}`;

  const handleDownload = async () => {
    const canvas = document.querySelector('canvas');
    const blob = await canvasToImage(canvas, 'image/png'); // Change to 'image/jpeg' for JPEG format
    saveAs(blob, 'qrcode.png'); // Change file name and extension accordingly
  };


  const constructFullUrl = (network, url) => {
    const baseUrl = baseUrls[network];
    if (!baseUrl) return url;

    // If the url already starts with the base URL, return it as is
    if (url.startsWith(baseUrl)) return url;


    // Ensure the URL starts with a single slash if needed
    return baseUrl + (url.startsWith('/') ? url.slice(1) : url);
  };


  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleShareClick = () => {
    setSharePopover(true);
  };

  const handleShareClose = () => {
    setSharePopover(false);
  };

  let Logo = null;

  const [dialogOpen, setDialogOpen] = useState(false);
  const [showBorder, setShowBorder] = useState(false);
  const borderStyle = CardQrStyles?.border === 'border' ? { border: `2px solid ${CardQrStyles?.bordercolor || '#00000099'}`, borderRadius: '8px' } : {};

  const [ProfilePicture, setProfilePicture] = useState('');
  const [companyLogo, setcompanyLogo] = useState('');
  const [qrlogoCreation, setlogoCreation] = useState(null);

  useEffect(() => {
    if (cardDetails?.profile_pic && cardDetails?.profile_pic !== '') {
      setProfilePicture(cardDetails.profile_pic);
    }
    else {
      setProfilePicture(DefaultProfileBg);
    }

    if (cardDetails?.logo && cardDetails?.logo !== '') {
      if (cardDetails?.logo && cardDetails?.logo !== '') {
      setcompanyLogo(cardDetails.logo)
      const proxiedLogoUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/qr-image-proxy?url=${encodeURIComponent(cardDetails.logo)}&qr=true`;
      setlogoCreation(proxiedLogoUrl);
    }
    }
    else {
      setcompanyLogo(DefaultLogo);
    }
  }, [cardDetails]);

  const [qrCodeOptions, setQrCodeOptions] = useState({
    dotsOptions: {
      color: "#000000",
      type: "dots"
    },
    cornersSquareOptions: {
      color: "#000000",
      type: "square"
    },
    cornersDotOptions: {
      color: "#000000",
      type: "dot"
    },
    backgroundOptions: {
      color: ""
    }
  });

  const qrCodeRef = useRef(null);
  const qrCodeInstanceRef = useRef(null);
  // const [qrCodeSVG, setQrCodeSVG] = useState("");

  useEffect(() => {
    if (CardQrStyles) {
      setQrCodeOptions({
        dotsOptions: {
          color: CardQrStyles.qrPatterncolor ?? "#000000",
          type: CardQrStyles.qrPattern ?? "dots"
        },
        cornersSquareOptions: {
          color: CardQrStyles.eyeBallcolor ?? "#000000",
          type: CardQrStyles.eyeBall ?? "dot"
        },
        cornersDotOptions: {
          color: CardQrStyles.eyeFrameColor ?? "#000000",
          type: CardQrStyles.eyeFrame ?? "dot"
        },
        backgroundOptions: {
          color: CardQrStyles.addbgcolor ?? ""
        }
      });
    } else {
      setQrCodeOptions({
        dotsOptions: {
          color: "#000000",
          type: "dots"
        },
        cornersSquareOptions: {
          color: "#000000",
          type: "dot"
        },
        cornersDotOptions: {
          color: "#000000",
          type: "dot"
        },
        backgroundOptions: {
          color: ""
        }
      });
    }
  }, [CardQrStyles]);


  useEffect(() => {
    if (qrCodeRef.current) {
      if (qrlogoCreation && qrCodeInstanceRef.current) {
        // Update existing QR code instance with logo
        qrCodeInstanceRef.current.update({ data: url, ...qrCodeOptions, image: qrlogoCreation ?? undefined });
      } else if (!qrCodeInstanceRef.current) {
        // Create new QR code instance with logo
        const qrCode = new QRCodeStyling({
          width: 200,
          height: 200,
          data: url,
          ...qrCodeOptions,
          image: qrlogoCreation ?? undefined
        });
        qrCode.append(qrCodeRef.current);
        qrCodeInstanceRef.current = qrCode;
      } else {
        // Update existing QR code instance without logo
        qrCodeInstanceRef.current.update({ data: url, ...qrCodeOptions });
        if (companyLogo) {
          qrCodeInstanceRef.current.update({ image: qrlogoCreation });
        }
      }
    }

  }, [qrlogoCreation, url, qrCodeOptions, CardQrStyles, qrCodeOptions]);

  useEffect(() => {


    setUrl(`${process.env.REACT_APP_CARD_URL}/digital-identity/${CardQrStyles?.CardName || CardQrStyles?.CardType}/${objectId}`);


  }, [CardQrStyles.CardName]);


  const calculateAge = (dob) => {
    // If dob is null or undefined, return early
    if (!dob) {
      return null;
    }
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    // console.log("yeras old", age);

    return age > 0 ? age : null;
  };

  // Assuming cardDetails is an object containing DOB as one of its properties
  let age = calculateAge(userDetails.DOB);


  // const layoutStyle = CardStyles.layoutStyle ? CardStyles.layoutStyle : (CardStyles.CardType === 'Personal' ? '2' : '1');
  // const [layoutStyle, setLayoutStyle] = useState(() => CardStyles.layoutStyle ? CardStyles.layoutStyle : ((CardStyles.CardType === 'Personal' || CardStyles.CardType === 'Customize_Personal') ? '2' : '1'));

  const [layoutStyle, setLayoutStyle] = useState(() =>
    CardStyles.layoutStyle !== undefined && CardStyles.layoutStyle !== null
      ? CardStyles.layoutStyle
      : (CardStyles.CardType === 'Personal' || CardStyles.CardType === 'Customize_Personal')
        ? '2'
        : '1'
  );


  useEffect(() => {
    const newLayoutStyle = CardStyles.layoutStyle ? CardStyles.layoutStyle : (CardStyles.CardType === 'Personal' ? '2' : '1');
    setLayoutStyle(newLayoutStyle);
  }, [CardStyles.layoutStyle, CardStyles.CardType]);

  const layoutProps = {
    profilePicture: ProfilePicture,
    cardType: cardDetails?.CardType?.startsWith("Customize_") ? cardDetails?.CardName || "CardName" : cardDetails?.CardType,
    companyLogo,
    prefix: cardDetails.prefix,
    suffix: cardDetails.suffix,
    firstName,
    lastName,
    companyName: companyName,
    designation: userDesignation,
    title: cardDetails.title,
    colorPrimary: CardStyles.colorPrimary,
    colorSecondary: CardStyles.colorSecondary,
    colorTitle: CardStyles.colorTitle,
    bgColor,
    layoutColor,
    labelColor,
    handleOpenDialog,
    handleShareClick,
    phoneNo: ContactStyles?.mobile_number || userDetails.phone,
    emailId: ContactStyles?.email || userDetails.email,
    website: SocialLinks?.links?.find((link) => link?.network === "website") || undefined,
    address: [ContactStyles?.city, ContactStyles?.country].filter(Boolean), // Filters out any `null` or `undefined`
    userDetails: userDetails
  };
  const shouldShowProfessionalInfo = (
    cardDetails?.profession_department ||
    cardDetails?.employee_id ||
    cardDetails?.company_id ||
    cardDetails?.professional_email_id ||
    cardDetails?.company
  );

  const shouldShowProfessionalSection = (
    cardDetails?.CardType === "Professional" ||
    cardDetails?.CardType === "GenZ" ||
    cardDetails?.CardType === "Customize_GenZ" ||
    cardDetails?.CardType === "Customize_Professional"
  ) && shouldShowProfessionalInfo;

  const shouldShowContactSection = ContactStyles?.is_public && (
    ContactStyles?.address ||
    ContactStyles?.city ||
    ContactStyles?.state ||
    ContactStyles?.postal_code ||
    ContactStyles?.country
  );

  const maxImages = 5; // Maximum images to display in two rows (4 per row)
  const visibleImages = visibleFiles(AttachDocs.images).slice(0, maxImages);
  const [isModalOpen, setModalOpen] = useState(false);

  const handleViewMoreClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div /*style={{ fontStyle: CardStyles ? CardStyles.style : "Lato", fontFamily: CardStyles ? CardStyles.font : "Lato", fontWeight: getFontWeight(CardStyles.style), fontSize: CardStyles ? CardStyles.size : '', color: CardStyles ? CardStyles.colorSecondary : '' }}*/>
      <Box> {/*sx={{ border: "1px solid pink", backgroundColor: "white", borderRadius: 2, padding: "16px 5px 5px" }}*/}
        {/* To Hide some elements when using Preview inside a Modal */}
        {isInsideModal ? (<> </>) :
          (<Link
            to={`/view-card/${cardDetails?.CardName || cardDetails?.CardType}/${objectId}`}
            target='_blank'
            rel='noreferrer'
          >
            <div id='dialogue-root' className='mb-1 view-card-container' style={{ fontWeight: "600" }}>
              <span className='span-center-align'>
                <ExternalLinkIcon className='me-1' />
                View Card
              </span>
            </div>
          </Link>
          )}

        <div className="preview-card-container text-center">
          {!isInsideModal && <h5>Preview</h5>}
          <Box className="preview-card " sx={{ border: "2px solid #0000001F", borderRadius: 2, backgroundColor: CardStyles?.bgColor, backgroundColor: CardStyles?.bgColor, fontStyle: CardStyles ? CardStyles.style : "Lato", fontFamily: CardStyles ? CardStyles.font : "Lato", fontWeight: getFontWeight(CardStyles?.style), color: CardStyles ? CardStyles.colorSecondary : '' }}>
            <div id='Card-firstPart-createNew'>
              <div className='layout-container'>
                {renderLayout(layoutStyle, layoutProps)}
                {CardStyles?.layoutStyle === '2' ? (<> </>) :
                  <div className="mt-2 line-card">
                    <div className="line-blue" style={{ backgroundColor: layoutColor }}></div>
                    <div className="icon icon-alignment-card d-flex align-items-center justify-content-center">
                      <div className='icon-border me-3 flex-center' style={{ borderColor: layoutColor }}>
                        <ImQrcode className='icon-color' onClick={handleOpenDialog} />
                      </div>
                      <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: layoutColor }}>
                        {cardDetails?.is_professional_verified === true ? <VerifiedTickN /> : <NonVerifiedTickNew />}
                      </div>
                      <div className='icon-border flex-center' style={{ borderColor: layoutColor }}>
                        <IoMdShare className='icon-color' onClick={handleShareClick} />
                      </div>
                    </div>
                  </div>
                }

                <div className='summary-container word-break'>
                  {cardDetails.summary}
                </div>
              </div>

              <div className="dialogue-overlay" style={{ display: (dialogOpen || activeItem === 'QR Code') ? 'block' : 'none' }} onClick={handleCloseDialog}>
                <div className='Scanner-outline-preview'>
                  <div className='Displaying-QR'>
                    <span className='d-block text-center'>Scan me</span>
                    <div className={"qrCodeContainer"} style={borderStyle}>
                      <div className='flex-center' ref={qrCodeRef}></div>
                    </div>
                    <span className='d-block text-center'>scan or click to preview</span>
                  </div>
                </div>
              </div>
            </div>

            {/* <BootstrapDialog
              onClose={handleShareClose}
              aria-labelledby="customized-dialog-title"
              open={sharePopover}
              className="share-dialog"
            >
              <DialogTitle
                id="customized-dialog-title"
              ></DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleShareClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
              <DialogContent
                dividers
                sx={{ m: 0, p: 2, width: 500, height: 500 }}
              >
                <Typography gutterBottom>
                  <div className="text-center">
                    <a
                      href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${cardDetails.CardType}/${objectId}`}
                      rel="noopener noreferrer"
                      target='_blank'
                    >
                      <QrCodeCard id={cardDetails.CardName} />
                    </a>
                  </div>
                </Typography>
                <Typography className="text-center" gutterBottom>
                  <button className="download-share-button mt-n1" onClick={handleDownload}>
                    <Download className="dowload-share-icon" />
                    Download QR Code
                  </button>
                </Typography>
                <Typography className="mt-3" gutterBottom>
                  <div className="share-qr-content">
                    Share with your friends
                  </div>
                  <div className="share-qr-subcontent text-left mt-2">
                    Connect and Share with Friends
                  </div>
                </Typography>
                <Typography gutterBottom>
                  <div className="row mt-3">
                    <div className="d-flex">
                      <a href="#facebook-link" target='_blank' rel='noreferrer'>
                        <img src={facebook} alt="facebook" className="share-icons mr-3" />
                      </a>
                      <a href={whatsappLink} target='_blank' rel='noreferrer'>
                        <img src={whatsapp} alt='whatsapp' className="share-icons mr-3" />
                      </a>
                      <a href="#instagram-link" target='_blank' rel='noreferrer'>
                        <img src={insta} alt="instagram" className="share-icons mr-3" />
                      </a>
                      <a href="#linkedin-link" target='_blank' rel='noreferrer'>
                        <img src={linkedin} alt="linkedin" className="share-icons mr-3" />
                      </a>
                      <a href="#signal-link" target='_blank' rel='noreferrer'>
                        <img src={signal} alt="signal" className="share-icons mr-3" />
                      </a>
                      <a href={telegramLink} target='_blank' rel='noreferrer'>
                        <img src={telegram} alt='telegram' className="share-icons" />
                      </a>
                    </div>
                  </div>

                </Typography>
                <button className="continueButton primary-button share-button">
                  Share
                </button>
              </DialogContent>
            </BootstrapDialog> */}

            <ShareQR cardType={cardDetails?.CardName || cardDetails?.CardType} sharePopover={sharePopover} onClose={handleShareClose} />

            <div className='quick-link-container ms-3 me-3 mt-4'>
              {ContactStyles?.call_visible && (
                <div className='flex-center flex-column quick-link-icon'>
                  <a className='flex-center flex-column' href={`tel:${ContactStyles.mobile_number || userDetails.phone}`} target='_blank' rel='noreferrer'>
                    <div className='icon icon-outside contact-icon-shadow m-0' style={{ backgroundColor: layoutColor }}><MdOutlinePhoneIphone className='icon-color3' /></div>
                    <div className='text-center'>Call</div>
                  </a>
                </div>)}
              {ContactStyles?.sms_visible && (
                <div className='flex-center flex-column quick-link-icon'>
                  <a className='flex-center flex-column' href={`tel:${ContactStyles.mobile_number || userDetails.phone}`} target='_blank' rel='noreferrer'>
                    <div className='icon icon-outside contact-icon-shadow m-0' style={{ backgroundColor: layoutColor }}><SmsIcon className='icon-color3' /></div>
                    <div className='text-center'>SMS</div>
                  </a>
                </div>)}
              {ContactStyles?.email_visible && (
                <div className='flex-center flex-column quick-link-icon'>
                  <a className='flex-center flex-column' href={`mailto:${ContactStyles.email || userDetails.email}`} target='_blank' rel='noreferrer'>
                    <div className='icon icon-outside contact-icon-shadow m-0' style={{ backgroundColor: layoutColor }}><EmailIcon className='icon-color3' /></div>
                    <div className='text-center'>E-mail</div>
                  </a>
                </div>)}
              {ContactStyles?.whatsapp_visible && (
                <div className='flex-center flex-column quick-link-icon'>
                  <a className='flex-center flex-column' href={`https://wa.me/${ContactStyles.mobile_number || userDetails.phone}`} target='_blank' rel='noreferrer'>
                    <div className='icon icon-outside contact-icon-shadow m-0' style={{ backgroundColor: layoutColor }}><WhatsappFilled className='icon-color3' /></div>
                    <div className='text-center'>WhatsApp</div>
                  </a>
                </div>)}
            </div>

            {age &&
              <div className='mt-4 mx-3'>
                <h5 className='d-flex justify-content-start text-left' style={{ color: CardStyles?.colorTitle || '' }}>Personal Details</h5>
                <div className='box-paragraph'>
                  <div className='d-flex justify-content-start'>
                    <EventIcon />
                    <div className='mx-1'>Age: </div>
                    <div className='mx-2'> {age} Years Old</div>
                  </div>
                </div>
              </div>
            }
            <div>
              {cardDetails?.additionalFields && Object.keys(cardDetails.additionalFields).length > 0 && (
                <div className='mt-4 mx-3'>
                  <h5 className='d-flex justify-content-start text-left' style={{ color: CardStyles?.colorTitle || '' }}>
                    Additional Information
                  </h5>
                  <div className='box-paragraph text-start' style={{ fontSize: "16px", lineHeight: "24px" }}>
                    {Object.keys(cardDetails.additionalFields).map((key) => (
                      <div key={key} className='d-flex justify-content-start'>
                        <div className='ms-1'>{key}:</div>
                        <div className='mx-2'>{cardDetails.additionalFields[key]}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>


            {shouldShowProfessionalSection && (
              <div className='mt-4 mx-3'>
                <h5 className='d-flex justify-content-start text-left' style={{ color: CardStyles?.colorTitle || '' }}>
                  Professional Information
                </h5>
                <div className='box-paragraph text-start' style={{ fontSize: "16px", lineHeight: "24px", borderColor: layoutColor }}>
                  {[
                    { label: 'Department', value: cardDetails?.profession_department },
                    { label: 'Company', value: cardDetails?.company },
                    { label: 'Employee ID', value: cardDetails?.employee_id },
                    { label: 'Company ID', value: cardDetails?.company_id },
                    { label: 'Email ID', value: cardDetails?.professional_email_id },

                  ]
                    .filter((field) => field.value) // Filter out fields with no value
                    .map((field, index) => (
                      <div key={index} className={`d-flex justify-content-start flex-wrap`}>
                        <div className='ms-1'>{field.label}:</div>
                        <div className='mx-1 fw-semibold'>{field.value}</div>
                      </div>
                    ))}
                </div>
              </div>
            )}

            <div className='preview-social-icons-container'>
              {anySocialIconsVisible && (
                <div className='mt-4 mx-3 social-icons-wrapper'>
                  {socialLinksSections.map(section => (
                    (section.title !== "Recommended") && ( // Exclude Recommended section
                      <div className='my-4' key={section.title}>
                        {SocialLinks.links.some(link => link.visible && section.links.some(secLink => secLink.network === link.network)) && ( // Check if any visible icons under this section
                          <React.Fragment>
                            <h5 className='mb-2' style={{ color: CardStyles?.colorTitle || '' }}>{getDisplayTitle(section.title)}</h5>
                            <div className="social-icons-rows">
                              {SocialLinks.links.map((link) => (
                                link.visible && section.links.some(secLink => secLink.network === link.network) && (
                                  <a key={link.network} href={constructFullUrl(link.network, link.url)} target='_blank' rel='nonreferrer'>
                                    <div className="square-box">
                                      {/* Get the icon using getIconAndLabel */}
                                      {(() => {
                                        const { icon: Icon } = getIconAndLabel(link.network);
                                        return Icon ? <Icon className="social-icon svg-icon-32px" /> : null;
                                      })()}
                                    </div>
                                  </a>
                                )
                              ))}
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                    )
                  ))}
                </div>
              )}
            </div>

            <div className='mt-4 mx-3'>
              {/* <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> Files </h5> */}
              {AttachDocs.images.length === 0 && AttachDocs.videos.length === 0 && AttachDocs.others.length === 0 ? (<></>
                // <p>No files uploaded yet.</p>
              ) : (
                <div>
                  {visibleImages.length > 0 && (
                    <div>
                      <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> Images </h5>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', maxHeight: '220px', justifyContent: "center" }}>
                        {visibleImages.map((file, index) => (
                          <div key={index} style={{ width: '99px', height: '100px', boxSizing: 'border-box' }}>
                            <img src={file.data} alt={file.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
                          </div>
                        ))}
                        {AttachDocs.images.length > maxImages && (
                          <div
                            style={{ width: '99px', height: '100px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#e0e0e0', borderRadius: '8px' }}
                            onClick={handleViewMoreClick}
                          >
                            <span>{AttachDocs.images.length - maxImages}+ View More</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {visibleFiles(AttachDocs.videos).length > 0 && (
                    <div className='mt-2'>
                      <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> Videos </h5>
                      {visibleFiles(AttachDocs.videos).map((file, index) => (
                        <div key={index}>
                          {/* <video controls className='preview-media-display'>
                            <source src={`data:${file.type};base64,${file.data}`} type={file.type} />
                            Your browser does not support the video tag.
                          </video> */}
                          <ReactPlayer url={file.data} loop controls className='mx-auto preview-media-display' />
                          <p>{file.name}</p>
                        </div>
                      ))}
                    </div>
                  )}
                  {visibleFiles(AttachDocs.others).length > 0 && (
                    <div className='mt-2'>
                      <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> Files </h5>
                      {visibleFiles(AttachDocs.others).map((file, index) => (
                        <div key={index} className="mb-3">
                          {/* <a href={`data:${file.type};base64,${file.data}`} target='_blank' rel='noreferrer'> */}
                          <PreviewFileItem file={file} fontColor="#00000099" />
                          {/* </a> */}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            <Modal open={isModalOpen} onClose={handleCloseModal}>
              <Box sx={{ maxWidth: '80%', margin: 'auto', padding: '20px', backgroundColor: 'white', borderRadius: '8px', overflowY: 'auto' }}>
                <h2>All Images</h2>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {visibleFiles(AttachDocs.images).map((file, index) => (
                    <div key={index} style={{ flex: '1 1 calc(25% - 10px)', boxSizing: 'border-box' }}>
                      <img src={file.data} alt={file.name} style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '8px' }} />
                    </div>
                  ))}
                </div>
              </Box>
            </Modal>

            {/* <div className='mt-4 mx-3'>
              <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> My Content </h5>
            </div>

            <div className='mt-4 mx-3'>
              <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> My Payment </h5>
            </div> */}
            {latitude !== null && longitude !== null && (
              <div className='my-2'>
                <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> Location</h5>
                <div className="professional-map-containerNew mt-3 flex-center width-auto">
                  {/* <MapIntegration style={{ borderRadius: "6px" }} latitude={latitude} longitude={longitude} /> */}
                  <MapWithAddress address={fullAddress} style={{ borderRadius: "6px" }} />
                </div>
              </div>
            )}


            {shouldShowContactSection && (
              <div className='my-4 mx-3'>
                <h5 className='d-flex justify-content-start text-left' style={{ color: ContactStyles?.colorTitle || '' }}>
                  Contact Information
                </h5>
                <div className='box-paragraph text-start' style={{ fontSize: "16px", lineHeight: "24px" }}>
                  {[
                    { label: 'Address', value: ContactStyles?.address },
                    { label: 'City', value: ContactStyles?.city },
                    { label: 'State', value: ContactStyles?.state },
                    { label: 'Country', value: ContactStyles?.country },
                    { label: 'Postal', value: ContactStyles?.postal_code },
                  ]
                    .filter((field) => field.value) // Filter out fields with no value
                    .map((field, index) => (
                      <div key={index} className='d-flex justify-content-start'>
                        <div className='ms-1'>{field.label}:</div>
                        <div className='mx-2'>{field.value}</div>
                      </div>
                    ))}
                </div>
              </div>
            )}

          </Box>
        </div>
      </Box>
    </div>
  )
}

export default CreatePreview